import axios from 'axios';
import React, { useState } from 'react';
import { Button, Icon, Select, Toasts } from '@fourthwall/components';
import { RefreshIcon } from '@fourthwall/icons';
import * as S from './MailchimpCreateStore.styled';
const CREATE_NEW_LIST_VALUE = 'create-new';
export const MailchimpCreateStore = ({ createStore, isCreatingStore, lists, refreshLists, isRefreshing, }) => {
    const [selectedListId, setSelectedListId] = useState(lists[0]?.listId || CREATE_NEW_LIST_VALUE);
    const handleCreateStore = async () => {
        try {
            if (selectedListId === CREATE_NEW_LIST_VALUE) {
                await createStore(undefined);
            }
            else {
                await createStore(selectedListId);
            }
        }
        catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 403) {
                Toasts.notify('Access denied. This is likely because you have too many lists or stores in your Mailchimp account. Please try going through and deleting some.', { type: 'error' });
            }
            else {
                Toasts.notify('Failed to refresh Mailchimp lists. Please try again.', { type: 'error' });
                console.error('Failed to create Mailchimp store:', error);
            }
        }
    };
    const handleRefreshLists = async () => {
        try {
            await refreshLists();
        }
        catch (error) {
            // Error handling is now done in the useMailchimp hook
            console.error('Failed to refresh Mailchimp lists:', error);
        }
    };
    const selectOptions = [
        ...lists.map((list) => ({
            value: list.listId,
            label: list.listName,
        })),
        {
            value: CREATE_NEW_LIST_VALUE,
            label: '+ Create New Audience',
        },
    ];
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, "Connect your Audience"),
        React.createElement(S.Description, null,
            React.createElement("li", null, "Connect your Fourthwall products with Mailchimp by selecting or creating an audience."),
            React.createElement("li", null, "If you have ecommerce features enabled, a store will be created using the audience."),
            React.createElement("li", null, "Otherwise, your data will be synced to the audience directly in a different way.")),
        React.createElement(S.FormSection, null,
            React.createElement(S.SelectWithRefreshContainer, null,
                React.createElement(Select, { label: "Select Mailchimp Audience", value: selectedListId, options: selectOptions, onValueChange: setSelectedListId, fullWidth: true }),
                React.createElement(Button, { icon: React.createElement(Icon, { component: RefreshIcon, width: 16, height: 16 }), onClick: handleRefreshLists, loading: isRefreshing, disabled: isRefreshing }))),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Connect", appearance: "primary", onClick: handleCreateStore, loading: isCreatingStore, disabled: isCreatingStore }))));
};
